<template>
  <aside class="promo-config remove-config">
    <div class="config-body">
      <section class="config-section">
        <div class="section-row">
          <label class="section-label">抠图指令</label>
        </div>
        <div v-if="workbench.cutTab === 'doubao'" class="textarea-wrap">
          <textarea
            v-model="workbench.doubao.prompt"
            rows="6"
            class="section-textarea cut-command-textarea"
            placeholder="输入抠图和背景重绘的具体要求..."
          ></textarea>
          <div class="textarea-meta">
            <span class="badge-muted">ZH/EN</span>
            <span class="text-dim tiny">{{ (workbench.doubao.prompt || '').length }}/1000</span>
          </div>
        </div>
        <div v-else class="ref-empty">本地极速模式不需要输入抠图指令。</div>
      </section>

      <section class="config-section">
        <div class="section-row">
          <label class="section-label">生成参数</label>
        </div>
        <div class="ratio-cards remove-ratio-cards">
          <button
            v-for="ratio in workbench.ratioOptions"
            :key="ratio.value"
            class="ratio-card"
            :class="{
              active: ratio.value === selectedRatio,
              span3: ratio.value === '16:9' || ratio.value === '9:16'
            }"
            type="button"
            @click="selectRatio(ratio)"
          >
            <div class="ratio-rect" :class="'ratio-' + ratio.value.replace(':', '-')"></div>
            <div class="ratio-label">{{ ratio.value }}</div>
            <div v-if="ratio.value === selectedRatio" class="ratio-check">✓</div>
          </button>
        </div>
      </section>
    </div>

    <div class="config-footer remove-config-footer">
      <div class="hint" style="text-align:center;margin-bottom:6px;font-size:12px;color:#888;">
        请上传同一产品的 1-3 个角度图片，抠图结果将作为一组传给后续功能
      </div>
      <button class="primary-btn" :disabled="isBatchProcessing || !hasActiveUpload" @click="workbench.startCut">
        {{ isBatchProcessing ? '处理中...' : '开始抠图' }}
      </button>

      <div class="action-meta">
        <span class="hint">{{ workbench.batchCutRunning ? '正在批量处理...' : '预计耗时 2-5 秒' }}</span>
        <span class="hint mono">{{ workbench.activeStatus || 'Ready' }}</span>
      </div>

      <div class="status-row">
        <span class="status" v-if="workbench.activeError">{{ workbench.activeError }}</span>
        <span class="status ok" v-if="workbench.activeStatus && !workbench.activeError">{{ workbench.activeStatus }}</span>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()

const selectedRatio = computed(() => {
  const current = workbench.ratioOptions.find((item) => item.size === workbench.doubao.size)
  return current?.value || '1:1'
})

const hasActiveUpload = computed(() =>
  workbench.cutTab === 'local' ? !!workbench.local.preview : !!workbench.doubao.preview
)

const isBatchProcessing = computed(() => workbench.batchCutRunning || workbench.activeLoading)

const selectRatio = (ratio) => {
  workbench.doubao.size = ratio.size
}
</script>
